/**
 * Rends le header sticky au scroll.
 */
export const stickyHeader = () => {
    const header = document.getElementById('myHeader');
    const sticky = header.offsetTop;

    if (window.pageYOffset > sticky) {
        header.classList.add('sticky');
    } else {
        header.classList.remove('sticky');
    }
};
